import { Button, Modal } from 'antd';
import styled from 'styled-components';

export const HorizontalModal = styled(Modal)`
  width: 488px;

  .ant-modal-content {
    padding: 0;
  }

  .ant-modal-header {
    padding: 28px 0;
    border-bottom: 1px solid var(--light-gray);

    .ant-modal-title {
      line-height: 20px;
    }

    @media screen and (max-width: 768px) {
      padding: 4rem 0;
    }
  }

  .ant-modal-title {
    text-align: center;
    padding: 0 100px;

    @media screen and (max-width: 768px) {
      padding: 0 12rem;
    }
  }

  .ant-modal-body {
    padding: 40px 40px 16px;
    position: relative;
  }

  .ant-modal-footer {
    padding: 0 40px 40px;

    @media screen and (max-width: 768px) {
      padding: 0 6rem 6rem;
    }
  }

  &.no-footer .ant-modal-body {
    padding-bottom: 40px;
  }

  &.no-padding-body .ant-modal-body {
    padding: 0;
  }

  .prev-btn {
    position: absolute;
    top: 28px;
    z-index: 1010;
    inset-inline-start: 22px;

    color: var(--primary);
    font-weight: 600;
    line-height: 1;
    text-decoration: none;

    background: transparent;
    outline: 0;
    border-radius: 4px;
    padding: 0;
    width: 22px;
    height: 22px;
    border: 0;

    cursor: pointer;
    transition: color 0.2s, background-color 0.2s;

    &:hover {
      color: rgba(0, 0, 0, 0.88);
      background-color: rgba(0, 0, 0, 0.06);
      text-decoration: none;
    }
  }
`;

export const VerticalModal = styled(HorizontalModal)`
  .ant-modal-footer {
    display: flex;
    flex-direction: column-reverse;

    .ant-btn {
      width: 100%;
    }
  }
`;

export const GoBackButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;

  box-shadow: none;

  &.ant-btn-text:not(:disabled):active {
    background-color: rgba(0, 0, 0, 0.15);
  }

  svg {
    width: 14px;
  }

  path {
    fill: var(--primary);
  }
`;

// Informative modal
export const HorizontalInformativeModal = styled(Modal)`
  width: 488px;

  .ant-modal-content {
    padding: 40px 30px 30px;
  }

  .ant-modal-body {
    margin: 12px 0 30px;
    font-weight: 500;
  }

  .iconWrapper {
    width: 92px;
    height: 92px;
    border-radius: 50%;
    background-color: var(--light-pink);
    margin-bottom: 20px;

    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      path {
        fill: var(--primary);
      }
    }
  }

  &.error .iconWrapper {
    background-color: var(--light-error);
    svg path {
      fill: var(--error);
    }
  }

  @media screen and (max-width: 768px) {
    .ant-modal-content {
      padding: 6rem;
    }
  }
`;

export const VerticalInformativeModal = styled(HorizontalInformativeModal)`
  .ant-modal-title {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    text-wrap: balance;
  }

  .ant-modal-body {
    text-align: center;
  }

  .ant-modal-footer {
    display: flex;
    flex-direction: column-reverse;

    .ant-btn {
      width: 100%;
    }
  }
`;

export const ContentConfirmModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 32px;

  .icon-css {
    display: flex;
    margin: 0 auto;
    justify-content: center;
    width: 92px;
    height: 92px;
    background-color: var(--light-pink);
    align-items: center;
    border-radius: 50%;
  }

  .text-css {
    padding-top: 20px;

    .ant-space-item {
      font-weight: 500;

      &:first-child {
        font-size: 16px;
        text-align: center;
      }
    }
  }
`;
